import { useDeleteUserMutation } from "@graphql/users/users.g";
import { ComponentProps } from "react";

import { UpdateUserForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";
import { Dropdown } from "@design-system/Dropdown/Dropdown";
import { IconButton } from "@design-system/IconButton/IconButton";

type Props = {
  userId: string;
  onDeleteSuccess: () => void;
  onUpdateUserSuccess: ComponentProps<
    typeof UpdateUserForm
  >["onUpdateUserSuccess"];
};

export const UserCard = ({
  userId,
  onDeleteSuccess,
  onUpdateUserSuccess,
}: Props) => {
  const deleteUserMutation = useDeleteUserMutation();
  const deleteUser = deleteUserMutation.mutateAsync;

  const handleDeleteClick = async () => {
    await deleteUser({ userId });
    onDeleteSuccess?.();
  };

  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Staff member</Card.Header.Title>
        <Card.Header.Actions>
          <Dropdown trigger={<IconButton icon="faEllipsisVertical" />}>
            <Dropdown.Option
              label="Delete"
              icon="faTrash"
              onSelect={handleDeleteClick}
            />
          </Dropdown>
        </Card.Header.Actions>
      </Card.Header>
      <Card.Body>
        <UpdateUserForm
          userId={userId}
          onUpdateUserSuccess={onUpdateUserSuccess}
        />
      </Card.Body>
    </Card>
  );
};
